const NS = 'HomepageHeroBannerBlock';
const CLS = 'homepageHeroBannerBlock';

import { animateScrollRevealMixinBlock } from '../../mixins/animateScrollRevealMixinBlock/animateScrollRevealMixinBlock';
import { gsap } from 'gsap/dist/gsap';

export class HomepageHeroBannerBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$tplScroller = $('.tpl-scroller');
		this.$scrollToButton = this.$element.find(`.${CLS}-scrollTo`);

		this.initAnimateScrollReveal(this, CLS);

		// Scroll to next block (with top margin and nav bar offset included)
		this.$scrollToButton.on('click', () => {
			const elOffsetTop = $(this.$element.next()).offset().top; // block y pos
			const elMarginTop = parseInt($(this.$element.next()).css('margin-top')); // block margin top
			const targetY = elOffsetTop - elMarginTop - 60; // minus nav height
			// console.log(elOffsetTop, elMarginTop, targetY);
			gsap.to(this.$tplScroller[0], {
				scrollTo: targetY,
				duration: 0.75
			});
		});

		// Video Masthead
		if($('[data-masthead-video]', element).length) {
			const videoBackground = this.$element.find(`[data-masthead-video]`);
			const videoBackgroundSrc = videoBackground.attr('data-src');

			setTimeout(function() {
				videoBackground.attr('src', videoBackgroundSrc);
			}, 1000);
		
			videoBackground.on('loadeddata', function(e) {
				// console.log('loadeddata', e.target.duration)
				videoBackground.addClass('loadeddata');
			});

			videoBackground.on('load', function(e) {
				// console.log('load', e.target.duration)
				videoBackground.addClass('load');
			});
		}
	}
}

Object.assign(HomepageHeroBannerBlock.prototype, animateScrollRevealMixinBlock);
